import { useCallback } from "react";
import {
  useGetEconomicSectors,
  useGetGenders,
  useGetProductTransactionCodes,
  useGetProductOwnerships,
  useGetProductCategories,
} from "../../../hooks/queries/useMerchantQueries";

export const useMerchantReferenceData = () => {
  const {
    data: economicSectors = [],
    isLoading: economicSectorsLoading,
    isError: isEconomicSectorsError,
  } = useGetEconomicSectors();

  const {
    data: genders = [],
    isLoading: gendersLoading,
    isError: isGendersError,
  } = useGetGenders();

  const {
    data: productTransactionCodes = [],
    isLoading: productTransactionCodesLoading,
    isError: isProductTransactionCodesError,
  } = useGetProductTransactionCodes();

  const {
    data: productOwnerships = [],
    isLoading: productOwnershipsLoading,
    isError: isProductOwnershipsError,
  } = useGetProductOwnerships();

  const {
    data: productCategories = [],
    isLoading: productCategoriesLoading,
    isError: isProductCategoriesError,
  } = useGetProductCategories();

  const getAllErrorItemNames = useCallback(() => {
    const errors = [];
    if (isEconomicSectorsError) errors.push("economic sectors");
    if (isGendersError) errors.push("genders");
    if (isProductTransactionCodesError) errors.push("product transaction codes");
    if (isProductOwnershipsError) errors.push("product ownerships");
    if (isProductCategoriesError) errors.push("product categories");
    return errors;
  }, [
    isEconomicSectorsError,
    isGendersError,
    isProductTransactionCodesError,
    isProductOwnershipsError,
    isProductCategoriesError,
  ]);

  const isAnyLoading = 
    economicSectorsLoading || 
    gendersLoading || 
    productTransactionCodesLoading || 
    productOwnershipsLoading || 
    productCategoriesLoading;

  return {
    referenceData: {
      economicSectors,
      genders,
      productTransactionCodes,
      productOwnerships,
      productCategories,
    },

    loadingStates: {
      economicSectorsLoading,
      gendersLoading,
      productTransactionCodesLoading,
      productOwnershipsLoading,
      productCategoriesLoading,
    },

    errorStates: {
      economicSectorsError: isEconomicSectorsError,
      gendersError: isGendersError,
      productTransactionCodesError: isProductTransactionCodesError,
      productOwnershipsError: isProductOwnershipsError,
      productCategoriesError: isProductCategoriesError,
    },

    getAllErrorItemNames,
    isAnyLoading,
  };
};

export default useMerchantReferenceData;
